import React from "react";
import { useDistribuicoes } from "./hooks/useDistribuicoes";
import DistribuicoesTable from "./components/DistribuicoesTable";
import FilterBar from "./components/FilterBar";

/**
 * Componente principal de Distribuições
 */
const Distribuicoes = () => {
  // Hook personalizado para gerenciar a lógica de negócio
  const {
    distribuicoes,
    loading,
    error,
    statusOptions,
    selectedStatus,
    dataInicio,
    dataFim,
    numeroProcesso,
    selectedItems,
    handleStatusChange,
    handleDataInicioChange,
    handleDataFimChange,
    handleNumeroProcessoChange,
  } = useDistribuicoes();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64 text-muted-foreground text-sm">
        Carregando dados...
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-red-50 border border-red-200 text-red-700 rounded-lg p-4 text-sm">
        Erro ao carregar dados: {error}
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-foreground">Distribuições</h1>
        <p className="text-sm text-muted-foreground mt-1">Lista de processos distribuídos</p>
      </div>
      
      {/* Barra de filtros e ações */}
      <FilterBar 
        statusOptions={statusOptions}
        selectedStatus={selectedStatus}
        dataInicio={dataInicio}
        dataFim={dataFim}
        numeroProcesso={numeroProcesso}
        selectedItemsCount={selectedItems.length}
        onStatusChange={handleStatusChange}
        onDataInicioChange={handleDataInicioChange}
        onDataFimChange={handleDataFimChange}
        onNumeroProcessoChange={handleNumeroProcessoChange}
      />
      
      {/* Tabela de distribuições */}
      <DistribuicoesTable 
        distribuicoes={distribuicoes}
        selectedItems={selectedItems}
      />
    </div>
  );
};

export default Distribuicoes;
